/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
const RouterProvider = ({
  children
}) => {
  const router = useRouter();
  const currentUrl = useRef(router.asPath);
  useEffect(() => {
    // redirected from login
    sessionStorage.removeItem('isReloaded');
    sessionStorage.setItem('landed', 'true');
    router.events.on('routeChangeStart', handleOn);
    router.events.on('routeChangeComplete', handleOff);
    router.events.on('routeChangeError', handleOff);
    return () => {
      router.events.off('routeChangeStart', handleOn);
      router.events.off('routeChangeComplete', handleOff);
      router.events.off('routeChangeError', handleOff);
    };
  }, []);
  const handleOn = () => {
    currentUrl.current = window.location.href;
  };
  const handleOff = url => {
    const isUrlChanged = currentUrl.current !== window.location.href || url === '/';
    if (isUrlChanged) {
      sessionStorage.setItem('previous_page', currentUrl.current);
    }
  };
  return <>{children}</>;
};
export default RouterProvider;